import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer, closeDrawer, openDialog } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import SearchBar from "@/src/components/searchBar";
import { FieldUnit } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useState } from "react";

export default function FieldUnitPicker({
  title,
  current,
  onChange,
}: {
  title: string;
  current: FieldUnit | null | undefined;
  onChange: (newValue: FieldUnit) => void;
}) {
  const [currentUnit, setCurrentUnit] = useState(current);
  return (
    <div
      className="field"
      onClick={async () => {
        await openDialog({
          id: "fieldUnitPicker",
          title: "Choisir un élément",
          content: (
            <FieldUnitChoiceList
              current={current}
              onSelect={async (newValue) => {
                onChange(newValue);
                setCurrentUnit(newValue);
                closeDrawer("fieldUnitPicker");
              }}
            ></FieldUnitChoiceList>
          ),
          footer: <div></div>,
        });
      }}
    >
      <div className="label">{title}</div>
      <div className="bold card">{currentUnit?.name || "Non défini"}</div>
    </div>
  );
}

function FieldUnitChoiceList({
  current,
  onSelect,
}: {
  current: FieldUnit | null | undefined;
  onSelect: (newValue: FieldUnit) => void;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  async function addOne(searchKey: string) {
    let fieldUnit: FieldUnit | null | undefined = {
      name: `${searchKey || ""}`,

      creator: getUserId(),
    };

    fieldUnit = await apiFetch("fieldUnits", "addOne", { fieldUnit });
    if (fieldUnit) {
      onSelect(fieldUnit);
    }
  }

  return (
    <div>
      <FetchableList
        queryKey={["FieldUnitChoiceList", searchKey, reload]}
        queryFn={() => apiFetch("fieldUnits", "loadMany", { searchKey })}
        searchKey={searchKey}
        shouldFocus={true}
        onSearch={async (newValue) => {
          setSearchKey(newValue || "");
        }}
        onClick={async () => {
          addOne(searchKey || "");
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucune unité disponible
              <Button
                onClick={async () => {
                  let fieldUnit: FieldUnit = {
                    name: `${searchKey || ""}`,

                    creator: getUserId(),
                  };

                  await apiFetch("fieldUnits", "addOne", { fieldUnit });
                }}
              >
                Créer {searchKey}
              </Button>
            </div>
          )
        }
      >
        {(data) => (
          <div className="grid c4 mc2 gap10">
            {data?.map((unit, index) => {
              if (!unit) return null;
              return (
                <Card
                  key={uid()}
                  color="blue"
                  onClick={async () => {
                    onSelect(unit);
                  }}
                >
                  <div style={{maxWidth:"100px"}}>{unit.name}</div>
                </Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}
